import React from "react";
import Navbar from "../../component/Navbar";
import Footer from "../../component/Footer";
import SupportComp from "../../component/servicescomponent/SupportComp";

const Support = () => {
  return (
    <>
      <section className="usp_service_section">
        <Navbar />
        <SupportComp />
        <Footer />
      </section>
    </>
  );
};

export default Support;
